module.exports = __webpack_public_path__ + "img/shexiang.e7137421.png";